<script setup lang="ts">
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import type TripPackage from '@itinerary/trip/TripPackage';

interface IProps {
    tripPackage: TripPackage;
    isSelected?: boolean;
}
const { tripPackage, isSelected } = defineProps<IProps>();
const emit = defineEmits<{
    reserve: [];
}>();
const reserveText = computed(() =>
    /\d/.test(tripPackage.buyText) ? 'رزرو آنلاین' : tripPackage.buyText
);

const btnColorVariant = computed(() =>
    tripPackage.autoReserveEnabled ? 'secondary' : 'primary'
);
const reserveButtonIcon = computed(() =>
    tripPackage.reservable && !isSelected ? faArrowLeft : undefined
);

// why this calculate here and not in the priceclass
const discountPercent = computed(() =>
    !tripPackage.reservable
        ? 0
        : Math.round(
              ((tripPackage.singlePrice - tripPackage.singlePayable) /
                  tripPackage.singlePrice) *
                  1000
          ) / 10
);
</script>

<template>
    <div class="pricing-container">
        <mr-price-re
            v-if="discountPercent"
            :price="tripPackage.singlePrice"
            :percent="discountPercent"
            type="discount"
        />
        <div
            v-if="tripPackage.priceDescription && tripPackage.reservable"
            class="price-description-text"
        >
            {{ tripPackage.priceDescription }}
        </div>
        <mr-price-re
            v-if="tripPackage.singlePayable && !tripPackage.autoReserveEnabled"
            class="payable-price"
            :class="{
                selected: isSelected || !tripPackage.reservable,
            }"
            :price="tripPackage.singlePayable"
            :type="{ mobile: 'small' }"
        />
        <mr-button
            v-if="!isSelected && tripPackage.showReserveButton"
            full-width
            class="reserve-button"
            size="big"
            :left-icon="reserveButtonIcon"
            :disabled="
                !tripPackage.reservable && !tripPackage.autoReserveEnabled
            "
            :color="btnColorVariant"
            @click.stop="emit('reserve')"
        >
            <mr-typography
                size="x-large"
                weight="700"
                color="inherit"
                white-space="nowrap"
            >
                {{ reserveText }}
            </mr-typography>
        </mr-button>
    </div>
</template>

<style lang="scss" scoped>
.pricing-container {
    display: flex;
    flex-direction: column;
    margin-top: auto;
    @include mobile-only {
        flex-direction: row;
        margin: 0 auto 0 0;
    }
    .reserve-button {
        margin-top: 4px;
        @include mobile-only() {
            display: none;
        }
    }
    .price-description-text {
        display: flex;
        align-items: center;
        @include tg-s($w5);
        margin-right: 4px;
    }
    .payable-price {
        display: flex;
        margin-right: 4px;
        @include desktop-only {
            &.selected {
                align-self: flex-end;
                margin-left: 16px;
            }
        }
    }
}
</style>
